
import { Container, Row, Col } from "react-bootstrap";
import { CheckCircle, Mail, Phone, Clock, ArrowRight, Home, Package, Users, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

function Thanks() {
    const navigate = useNavigate();
    const [showContent, setShowContent] = useState(false);

    useEffect(() => {
        setShowContent(true);
    }, []);

    const nextSteps = [
        {
            icon: <Mail size={28} />,
            title: "Revisaremos tu solicitud",
            description: "Nuestro equipo analizará tu información",
            color: "#fe5000"
        },
        {
            icon: <Phone size={28} />,
            title: "Te contactaremos",
            description: "Un especialista se comunicará contigo",
            color: "#464f54"
        },
        {
            icon: <Clock size={28} />,
            title: "Respuesta en 24-48h",
            description: "Tiempo estimado de respuesta",
            color: "#fe5000"
        }
    ];

    const quickLinks = [
        {
            icon: <Home size={24} />,
            title: "Inicio",
            description: "Volver a la página principal",
            href: "/",
            color: "#fe5000"
        },
        {
            icon: <Package size={24} />,
            title: "Noticias",
            description: "Explora las noticias ma relevantes",
            href: "/noticias_novedades",
            color: "#464f54"
        },
        {
            icon: <Users size={24} />,
            title: "Nosotros",
            description: "Conoce más sobre nosotros",
            href: "/about",
            color: "#fe5000"
        },
        {
            icon: <FileText size={24} />,
            title: "Videos Informativos",
            description: "Explora videos novedosos",
            href: "/videos_novedades",
            color: "#464f54"
        }
    ];

    return (
        <section className="thanks-section">
            {/* Fondo decorativo */}
            <div className="thanks-background">
                <div className="thanks-shape thanks-shape-1"></div>
                <div className="thanks-shape thanks-shape-2"></div>
                <div className="thanks-confetti"></div>
            </div>

            <Container className={`thanks-container ${showContent ? 'show' : ''}`}>
                {/* Sección principal de agradecimiento */}
                <div className="thanks-hero">
                    {/* Icono de éxito animado */}
                    <div className="success-icon-wrapper">
                        <div className="success-circle"></div>
                        <CheckCircle size={80} className="success-icon" />
                    </div>

                    {/* Mensaje principal */}
                    <h1 className="thanks-title">
                        ¡Gracias por Contactarnos!
                    </h1>
                    
                    <p className="thanks-subtitle">
                        Hemos recibido tu solicitud exitosamente
                    </p>

                    <div className="thanks-message">
                        <p>
                            Un especialista del equipo de <strong>Salcedo Importaciones S.R.L.</strong> se 
                            pondrá en contacto contigo muy pronto para brindarte toda la información 
                            que necesitas.
                        </p>
                    </div>
                </div>

                {/* Próximos pasos */}
                <div className="next-steps-section">
                    <h2 className="section-title">¿Qué sigue ahora?</h2>
                    
                    <Row className="g-4">
                        {nextSteps.map((step, index) => (
                            <Col md={4} key={index}>
                                <div 
                                    className="step-card"
                                    style={{ animationDelay: `${index * 0.2}s` }}
                                >
                                    <div className="step-number">{index + 1}</div>
                                    <div 
                                        className="step-icon"
                                        style={{ background: `linear-gradient(135deg, ${step.color} 0%, ${step.color}dd 100%)` }}
                                    >
                                        {step.icon}
                                    </div>
                                    <h3 className="step-title">{step.title}</h3>
                                    <p className="step-description">{step.description}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* Divider decorativo */}
                <div className="thanks-divider">
                    <div className="divider-line"></div>
                    <div className="divider-icon">
                        <CheckCircle size={24} />
                    </div>
                    <div className="divider-line"></div>
                </div>

                {/* Mientras tanto... */}
                <div className="explore-section">
                    <h2 className="explore-title">
                        Mientras tanto, explora más sobre nosotros
                    </h2>
                    <p className="explore-subtitle">
                        Descubre todo lo que tenemos para ofrecerte
                    </p>

                    <Row className="g-4">
                        {quickLinks.map((link, index) => (
                            <Col md={6} lg={3} key={index}>
                                <div 
                                    className="quick-link-card"
                                    onClick={() => navigate(link.href)}
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >
                                    <div 
                                        className="quick-link-icon"
                                        style={{ background: `linear-gradient(135deg, ${link.color} 0%, ${link.color}dd 100%)` }}
                                    >
                                        {link.icon}
                                    </div>
                                    <h4 className="quick-link-title">{link.title}</h4>
                                    <p className="quick-link-description">{link.description}</p>
                                    <div className="quick-link-arrow">
                                        <ArrowRight size={20} />
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* CTA de contacto adicional */}
                <div className="contact-cta-section">
                    <div className="contact-cta-card">
                        <h3 className="cta-title-thanks">¿Tienes alguna pregunta urgente?</h3>
                        <p className="cta-description-thanks">
                            No dudes en comunicarte directamente con nosotros
                        </p>
                        <div className="cta-buttons-thanks">
                            <a href="http://wa.me/59160379365" rel="noreferrer" target="_blank" className="btn-thanks-phone">
                                <Phone size={20} />
                                <span>Llamar Ahora</span>
                            </a>
                            <a href="mailto:atencionalcliente@salcedoimport.com" className="btn-thanks-email">
                                <Mail size={20} />
                                <span>Enviar Email</span>
                            </a>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
}

export default Thanks;